export const exportFile = (
    filename: string,
    content: BlobPart[],
    mimeType: string = 'text/plain',
) => {
    const blob = new Blob(content, { type: mimeType })
    const url = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()

    URL.revokeObjectURL(url)
}
